module.exports = __webpack_public_path__ + "img/ssd.897de914.png";